import React, { useContext } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ProductsListController from '../products/productslist/ProductsListController'
import { ContentFooter } from '../layout/Content'
import { appContext } from '../../App'

function FindAndReplaceFooter() {
  const app = useContext(appContext)
  const setContent = app.content[1]
  return (
    <ContentFooter>
      <div id='find-and-replace-footer-container'>
        <button className="pospro-action-btn"
          type="button"
          onClick={() => setContent(<ProductsListController />)}>
          <FontAwesomeIcon icon='list-alt'/>&nbsp;Products List
        </button>
      </div>
      <style jsx="true">
      {`
        #find-and-replace-footer-container {
          display: flex;
          padding: 5px;
          justify-content: flex-end;
        }
      `}
      </style>
    </ContentFooter>
  );
}

export default FindAndReplaceFooter
